import React, { useState } from "react";

import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";

import CategorizedCreditUsage from "../../components/CategorizedCreditUsage";
import TitledPanel from "../../components/TitledPanel";
import UsageMetricsTestsModal from "../../components/UsageMetricsTestsModal";

import "./SubscriptionCategoryUsage.css";

export default function SubscriptionCategoryUsage({
  title = "Subscription Test Category Usage",
  categories = [],
  billingMode = "subscription",
  topupPlan = false,
  embedded = false,
  disabled = false,
  showUsageMeter = true,
  countLabel = "remaining",
  usedLabel = "",
}) {
  const [testsModalOpen, setTestsModalOpen] = useState(false);

  const panelClassName = [
    embedded ? "SubscriptionCategoryUsage--embedded" : "",
    disabled ? "SubscriptionCategoryUsage--disabled" : "",
  ].filter(Boolean).join(" ");

  return (
    <>
      <TitledPanel
        title={title}
        className={panelClassName}
        extra={(
          <Button
            type="text"
            onClick={() => setTestsModalOpen(true)}
          >
            View tests
            <EyeOutlined />
          </Button>
        )}
      >
        <div className="SubscriptionCategoryUsage__Categories">
          {categories.map((category) => (
            <CategorizedCreditUsage
              key={category.key}
              category={category}
              billingMode={billingMode}
              topupPlan={topupPlan}
              showUsageMeter={showUsageMeter}
              countLabel={countLabel}
              usedLabel={usedLabel}
            />
          ))}
        </div>
      </TitledPanel>

      <UsageMetricsTestsModal
        open={testsModalOpen}
        onClose={() => setTestsModalOpen(false)}
        categoryUsage={categories}
        billingMode={billingMode}
        topupPlan={topupPlan}
      />
    </>
  );
}
